// src/api/apiService.js
import apiClient from "./axiosInstance";

/**
 * Example API service function template
 * Replace with your actual API endpoints
 * 
 * @param {string} locale - The locale for the content (e.g., 'en', 'zh-HK').
 * @returns {Promise<object>} The data object from the API.
 */
export const getHeaderFooterData = async (locale = "en") => {
  const endpoint = "/cas-header-and-footer";
  const requestParams = {
    locale: locale,
    "populate[header_menu_items][populate][sub_menu_items][populate][sub_menu_items][populate]": "*",
    "populate[logo][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getHomePageData = async (locale = "en") => {
  const endpoint = "/cas-homepage";
  const requestParams = {
    locale: locale,
    "populate[products][populate]": "*",
    "populate[imgs][populate]": "*",
    "populate[news][populate]": "*",
    "populate[bottom][populate]": "*",
    "populate[banner][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getAboutUsData = async (locale = "en") => {
  const endpoint = "/cas-about-us";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[pdf_cover][populate]": "*",
    "populate[pdf_file][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getSupportPageData = async (locale = "en") => {
  const endpoint = "/cas-support";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[cas_support_categories][populate][image_list][populate]": "*",
    "populate[cas_support_categories][populate][video_list][populate]": "*",
    "populate[cas_support_categories][populate][logo][populate]": "*",
    "populate[cas_support_categories][populate][installation_list][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getDownloadPageData = async (locale = "en") => {
  const endpoint = "/cas-downloads";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[filter][populate][brand][populate]": "*",
    "populate[filter][populate][category][populate]": "*",
    "populate[cas_download_categories][populate][logo][populate]": "*",
    "populate[cas_download_categories][populate][download_files][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getNewsPageData = async (locale = "en") => {
  const endpoint = "/cas-news-page";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[filter][populate]": "*",
    "populate[cas_news][populate][list][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
      // News page can be a bit heavier; allow a longer timeout just for this call
      timeout: 30000,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getNewsletterData = async (locale = "en") => {
  const endpoint = "/cas-newsletters";
  const requestParams = {
    locale: locale,
    "populate[banner_img][populate]": "*",
    "populate[img][populate]": "*",
    "populate[info][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};




export const getContactUsPageData = async (locale = "en") => {
  const endpoint = "/cas-contact-us";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[Card][populate]": "*",
    "populate[addressCard][populate]": "*"
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getProductPageData = async (locale = "en") => {
  const endpoint = "/cas-product";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[cas_product_categories][populate][list][populate]": "*",
    "populate[cas_product_categories][populate][logo][populate]": "*",
    "populate[cas_product_categories][populate][introImg][populate]": "*",
    "populate[cas_sub_categories][populate][list][populate]": "*",
    "populate[cas_sub_categories][populate][description_image][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

export const getAllProductData = async (locale = "en") => {
  const endpoint = "/cas-all-product";
  const requestParams = {
    locale: locale,
    "populate[banner][populate]": "*",
    "populate[cas_raychem_items][populate][features][populate]": "*",
    "populate[cas_raychem_items][populate][downloads_pdf][populate]": "*",
    "populate[cas_raychem_items][populate][image_list][populate]": "*",
    "populate[cas_raychem_items][populate][video_list][populate]": "*",
    "populate[cas_sensaphone_items][populate][introduction][populate]": "*",
    "populate[cas_sensaphone_items][populate][overview][populate]": "*",
    "populate[cas_sensaphone_items][populate][specification][populate]": "*",
    "populate[cas_sensaphone_items][populate][features][populate]": "*",
    "populate[cas_sensaphone_items][populate][download][populate]": "*",
    "populate[cas_sensaphone_items][populate][pdf][populate]": "*",
    "populate[cas_sensaphone_items][populate][features_image][populate]": "*",
    "populate[cas_sensaphone_items][populate][features_video][populate]": "*",
    "populate[cas_sensaphone_items][populate][cas_special_case][populate][features][populate]": "*",
    "populate[cas_sensaphone_items][populate][cas_special_case][populate][download][populate]": "*",
    "populate[cas_sensaphone_items][populate][cas_special_case][populate][table][populate]": "*",
    "populate[cas_sensaphone_accessories_categories][populate][cas_sensaphone_accessories_items][populate][image][populate]": "*",
    "populate[cas_sensaphone_accessories_categories][populate][cas_sensaphone_accessories_items][populate][product_pdf][populate]": "*",
    "populate[cas_picobox_items][populate][features_image][populate]": "*",
    "populate[cas_picobox_items][populate][downloads_file][populate]": "*",
    "populate[cas_tracetek_items][populate][features_image][populate]": "*",
    "populate[cas_tracetek_items][populate][downloads_file][populate]": "*",
  };
  try {
    const responseData = await apiClient.get(endpoint, {
      params: requestParams,
    });
    return responseData.data;
  } catch (error) {
    throw error;
  }
};

// Add your API service functions here
